// src/errors.ts
var VexalynError = class extends Error {
  constructor(message) {
    super(message);
    this.name = "VexalynError";
  }
};
var PathSecurityError = class extends VexalynError {
  constructor(path) {
    super(`Path escapes workspace root: ${path}`);
    this.name = "PathSecurityError";
  }
};
var FileTooLargeError = class extends VexalynError {
  constructor(path, limit) {
    super(`File exceeds ${limit}: ${path}`);
    this.name = "FileTooLargeError";
  }
};
var PermissionDeniedError = class extends VexalynError {
  constructor(action, path) {
    super(`Permission denied for ${action}: ${path}`);
    this.name = "PermissionDeniedError";
  }
};
var FileEditConflictError = class extends VexalynError {
  constructor(path, matches) {
    super(`Expected exactly one edit match in ${path}, found ${matches}`);
    this.name = "FileEditConflictError";
  }
};
var ToolExecutionError = class extends VexalynError {
  constructor(tool, cause) {
    super(`Tool ${tool} failed: ${cause instanceof Error ? cause.message : String(cause)}`);
    this.name = "ToolExecutionError";
  }
};
var CommandValidationError = class extends VexalynError {
  constructor(command) {
    super(`Command is not allowed: ${command}`);
    this.name = "CommandValidationError";
  }
};
var CommandPermissionDeniedError = class extends VexalynError {
  constructor(command) {
    super(`Command permission denied: ${command}`);
    this.name = "CommandPermissionDeniedError";
  }
};
var CommandExecutionError = class extends VexalynError {
  constructor(command, cause) {
    super(`Command execution failed (${command}): ${cause instanceof Error ? cause.message : String(cause)}`);
    this.name = "CommandExecutionError";
  }
};
var CommandOutputLimitError = class extends VexalynError {
  constructor(command) {
    super(`Command output exceeded the limit: ${command}`);
    this.name = "CommandOutputLimitError";
  }
};
var CommandCwdSecurityError = class extends VexalynError {
  constructor(cwd) {
    super(`Command cwd escapes workspace root: ${cwd}`);
    this.name = "CommandCwdSecurityError";
  }
};
var CommandNotFoundError = class extends VexalynError {
  constructor(command) {
    super(`Command executable was not found: ${command}`);
    this.name = "CommandNotFoundError";
  }
};
var CommandCancelledError = class extends VexalynError {
  constructor(command) {
    super(`Command was cancelled: ${command}`);
    this.name = "CommandCancelledError";
  }
};
var PlanningError = class extends VexalynError {
  constructor(message) {
    super(message);
    this.name = "PlanningError";
  }
};
var MaxIterationsError = class extends VexalynError {
  constructor(limit) {
    super(`Agent exceeded max iterations: ${limit}`);
    this.name = "MaxIterationsError";
  }
};
var MaxRetriesError = class extends VexalynError {
  constructor(limit) {
    super(`Agent exceeded max retries: ${limit}`);
    this.name = "MaxRetriesError";
  }
};
var AgentCancelledError = class extends VexalynError {
  constructor() {
    super("Agent execution was cancelled");
    this.name = "AgentCancelledError";
  }
};
var VerificationError = class extends VexalynError {
  constructor(message) {
    super(message);
    this.name = "VerificationError";
  }
};
export {
  AgentCancelledError,
  CommandCancelledError,
  CommandCwdSecurityError,
  CommandExecutionError,
  CommandNotFoundError,
  CommandOutputLimitError,
  CommandPermissionDeniedError,
  CommandValidationError,
  FileEditConflictError,
  FileTooLargeError,
  MaxIterationsError,
  MaxRetriesError,
  PathSecurityError,
  PermissionDeniedError,
  PlanningError,
  ToolExecutionError,
  VerificationError,
  VexalynError
};
